module.exports = __webpack_public_path__ + "img/04.1bbbf008.svg";